<template>
  <div>
    <header-component />

    <div class="videoMain">
      <div class="w1300">
        <div class="box">
          <div class="tit">{{ shu.biaoti }}</div>
          <div class="info" v-html="shu.neirong"></div>
        </div>
      </div>
    </div>

    <footer-component />
  </div>
</template>

<script>
// 引用公用组件
import headerComponent from "@/components/header.vue";
import footerComponent from "@/components/footer.vue";

export default {
  name: "VideoIndex",
  data() {
    return {
      shu: {},
    };
  },
  components: {
    headerComponent,
    footerComponent,
  },
  created() {
    this.CSH();
  },
  computed: {},
  methods: {
    CSH() {
      var that = this;
      that.$post(
        "k=wenzhang&c=xiangqing",
        {
          id: "教程",
        },
        function(shu) {
          if (shu.shi == 1) {
            that.shu = shu.shu;
          }
        },
      );
    },
  },
};
</script>

<style lang="less" scoped>
.videoMain {
  padding: 1rem 0;

  .box {
    /deep/ .info {
      color: initial;

      h2 {
        margin: revert;
      }

      ol {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: inherit;
        }
      }

      ul {
        margin: revert;
        padding: revert;
        li {
          margin: inherit;
          padding: revert;
          list-style: initial;
        }
      }
    }
  }
}
</style>
